import classnames from 'classnames';
import { AnimatedChevronIcon } from 'src/components/BasicComponents/Icons';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { HEADER_HEIGHT } from '../PlayerSidebar';
import { HideButton } from './HideButton';
import type { ItemStyle } from './types';

export type TrackHeaderProps = {
  style: ItemStyle;
  isOpen: boolean;
  allHidden: boolean;
  onToggle: () => void;
  onHide: () => void;
  onUnhide: () => void;
};

export function TrackHeader({
  style,
  isOpen,
  allHidden,
  onToggle,
  onHide,
  onUnhide,
}: TrackHeaderProps): JSX.Element {
  return (
    <div
      className={classnames('starter-list-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div className="starter-list-header-item" {...onClickGenerator(onToggle)}>
        <AnimatedChevronIcon isOpen={isOpen} />
        &nbsp;
        <div className="starter-list-header-item-label">{t('list.TRACK')}</div>
        <HideButton allHidden={allHidden} onHide={onHide} onUnhide={onUnhide} />
      </div>
    </div>
  );
}
